import { RG_TYPE } from '../../types/rg-type.js';

const DefaultBeam = {
    type: RG_TYPE.Beam,
    size: [0.1, 0.1, 6],
    anchor: [0.5, 0.035, 0.5],
    name: 'beam',
    color: '#8E3939',
    children: []
};

export { DefaultBeam };
//# sourceMappingURL=default-beam.js.map
